export default {
  graphqlEndpoint:
    'https://zhmiafvekzai3lq6pib7wiktqi.appsync-api.us-east-1.amazonaws.com/graphql',
  region: 'us-east-1',
  authenticationType: 'AWS_IAM',
  apiKey: 'da2-3gvala6igrgc3hxfa3lnzxslr4',
};



// WEBPACK FOOTER //
// ./src/AppSync.js